import { h } from 'vue'
import { ColumnDef } from "@tanstack/vue-table";
import {i18n} from "@/utils/i18n";
import {Master} from "@/models/tables/master.interface";

export const masterColumns: ColumnDef<Master>[] = [
    {
        accessorKey: 'code',
        header: () => h('div', { class: 'text-right' }, i18n.global.t('column.code')),
        cell: ({ row }) => {
            const code = String(row.getValue('code'));
            return h('div', { class: 'text-right font-medium' }, code)
        },
    },
    {
        accessorKey: 'name',
        header: () => h('div', { class: 'text-right' }, i18n.global.t('column.name')),
        cell: ({ row }) => {
            const name = String(row.getValue('name'));
            return h('div', { class: 'text-right font-medium' }, name)
        },
    },
]
